import React from "react";

const roles = [
  {
    dates: "2024-04 — 2024-09",
    location: "Haifa, Israel",
    title: "Technical Optical Engineer at Mobileye",
    org: "Qualitest",
    description:
      "Led the validation of laser systems for an FMCW Lidar platform by developing MATLAB-based algorithms to analyze laser output images and detect accuracy deviations across experimental test series, ensuring high standards of precision and reliability in laser technology integration.",
  },
  {
    dates: "2020-06 — 2023-02",
    location: "Israel",
    title: "Signal Processing & Navigation Developer",
    org: "IDF — Hatal",
    description:
      "Took an active part in several systems for the Ground Forces, including a MATLAB detection algorithm that improved detection accuracy by more than 90% under blocker/scam interference.",
  },
];

const Experience = () => (
  <section id="experience" className="section">
    <div className="section-head">
      <span className="section-num">02</span>
      <h2>Experience</h2>
    </div>
    <div className="xp-list">
      {roles.map((role) => (
        <article className="xp" key={role.dates}>
          <div className="xp-meta">
            <span className="dates">{role.dates}</span>
            {role.location}
          </div>
          <div className="xp-body">
            <h3>{role.title}</h3>
            <span className="xp-org">{role.org}</span>
            <p>{role.description}</p>
          </div>
        </article>
      ))}
    </div>
  </section>
);

export default Experience;
